import { useTranslation } from 'react-i18next';
import { Button } from 'components/atoms';
import { MagellanPopups } from 'components/molecules';
import { Form } from 'components/organisms';
import { IEventForm } from 'components/organisms/forms/event/EventForm';
import { useParamId } from 'hooks/useParamId';
import i18next from 'i18next';
import { eventQueryToForm } from 'middleware/event/eventQueryToForm';
import { PiPencilSimpleLine } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDeleteEvent, useGetEvent } from 'services/events';
import { STATUS } from 'services/types';

const eventInitialValues: IEventForm = {
  version: 0,
  id: '',
  name: '',
  status: STATUS.draft,
  startDate: new Date().toISOString(),
  endDate: new Date().toISOString(),
  labels: [],
};

const Event = () => {
  const { t } = useTranslation();
  const eventId = useParamId('event');
  const { pathname } = useLocation();
  const { isPending, mutateAsync } = useDeleteEvent();

  const navigate = useNavigate();

  const { data: event, isLoading } = useGetEvent(eventId);

  const handleDeleteEvent = async () => {
    await mutateAsync(eventId, {
      onSuccess: () => navigate('/event'),
    });
  };

  return (
    <Form.Event
      i18nextPrefix='event'
      initialValues={
        event ? eventQueryToForm(event) : eventInitialValues
      }
      onSubmit={() => {}}
      tittle={event?.name ?? i18next.t('event.title.individual')}
      backPath='event'
      status={{ displayMode: true, isLoading }}
      topbarContent={
        <div className='flex gap-2 items-center'>
            <Button
              isClear
              onlyIcon
              onClick={() => {
              event &&
                navigate(`/event/edit/${eventId}/labels`, {
                    replace: true,
                  });
              }}>
              <Button.Description description={t('button.edit')} />

              <Button.Icon icon={<PiPencilSimpleLine />} />
            </Button>
            <MagellanPopups.DeleteWarning
            onRemove={handleDeleteEvent}
              removeLoading={isPending}
            name={event?.name}
            />
        </div>
      }
    />
  );
};

export default Event;
